import { memo } from "react";
import Carousel from "react-bootstrap/Carousel";
import CfdImageSingle from "./CfdImageSingle";
import "../CashForDeed.css";

const ImageCarousel = ({ item, activeTab, isModalOpen }) => {
  const imageList =
    activeTab === "saved" ? item?.propertyDetails?.imageList : item?.imageList;

  return (
    <>
      {imageList?.length > 0 ? (
        <Carousel
          controls
          slide={false}
          indicators={false}
          interval={null}
          onClick={(e) => e.stopPropagation()}
          className="cfd-image-carousel"
        >
          {imageList.map((imgItem, index) => (
            <Carousel.Item key={index}>
              <CfdImageSingle imageUrl={imgItem?.imageStoragePath} />
            </Carousel.Item>
          ))}
        </Carousel>
      ) : (
        <CfdImageSingle imageUrl={item?.imageUrl} />
      )}
    </>
  );
};

export default memo(ImageCarousel);
